import type { FC } from "react";
import React from "react";

import { hasValue } from "@core/foundation/types";

import { Button } from "@react/ui-primitives/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@react/ui-primitives/dialog";

interface UnrecognizedBarcodeDialogProps {
  readonly barcode: null | string;
  readonly onClose: () => void;
}

export const UnrecognizedBarcodeDialog: FC<UnrecognizedBarcodeDialogProps> = ({
  barcode,
  onClose,
}) => (
  <Dialog
    onOpenChange={open => {
      if (!open) {
        onClose();
      }
    }}
    open={hasValue(barcode)}
  >
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Product not recognized</DialogTitle>
        <DialogDescription>
          Open Food Facts has no calorie data for this barcode.
        </DialogDescription>
      </DialogHeader>
      <p className="text-center font-mono text-lg tracking-widest">{barcode}</p>
      <DialogFooter
        className="
          flex-col gap-2
          sm:flex-col
        "
      >
        {/* oxlint-disable-next-line no-warning-comments */}
        {/* TODO(APT-2373): wire the three actions. */}
        <Button disabled variant="outline">
          Recognize in ChatGPT
        </Button>
        <Button disabled variant="outline">
          Recognize in Claude
        </Button>
        <Button disabled variant="outline">
          Manual input
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
